import React from "react"
import classes from "./ResultSet.module.css"
import Select from "react-select"
import { default_single_style, get_reward_types, useLocalStorage } from "../../../Utils"
import { format_grade } from "../Gacha"
import { useTranslation } from "react-i18next"
import { defaultGachaData } from "../../../DefaultEntries"

const ControlInit = props => {
    const { t } = useTranslation()
    const reward_types = get_reward_types(t)
    const [currentPulls, setCurrentPulls] = useLocalStorage(
        `finder_${props.localKey}`,
        defaultGachaData(reward_types[0])
    )

    const addEntry = () => {
        const new_arr = [...currentPulls]
        new_arr.push({ Num: currentPulls.length + 1, Value: reward_types[0] })
        setCurrentPulls(new_arr)
    }

    const removeEntry = () => {
        const new_arr = [...currentPulls]
        new_arr.pop()
        setCurrentPulls(new_arr)
    }

    const changePull = (val, idx) => {
        const new_arr = [...currentPulls]
        new_arr[idx].Value = val
        setCurrentPulls(new_arr)
    }

    return (
        <div className={classes.WrapperNoScroll}>
            <div className={classes.ButtonArea}>
                <button className={classes.Button} disabled={currentPulls.length === 1} onClick={removeEntry}>
                    -
                </button>
                <span style={{ marginRight: 15 }}>{t("misc:SeedListing.Pull")}</span>
                <button className={classes.Button} onClick={addEntry}>
                    +
                </button>
            </div>
            <div className={classes.Gap}></div>
            {currentPulls.map((entry, idx) => {
                return (
                    <Entry
                        num={entry.Num}
                        key={entry.Num}
                        onChange={changePull}
                        idx={idx}
                        value={currentPulls[idx].Value}
                    />
                )
            })}
            <div className={classes.ButtonArea}>
                <button className={classes.Button} disabled={currentPulls.length === 1} onClick={removeEntry}>
                    -
                </button>
                <span style={{ marginRight: 15 }}>{t("misc:SeedListing.Pull")}</span>
                <button className={classes.Button} onClick={addEntry}>
                    +
                </button>
            </div>
            <div className={classes.Gap}></div>
            <div className={classes.ButtonArea}>
                <button className={classes.Button} onClick={() => props.findSeed(currentPulls)}>
                    {t("misc:Recovery.ButtonSearch")}
                </button>
            </div>
        </div>
    )
}

const Entry = props => {
    const { t } = useTranslation()
    const reward_types = get_reward_types(t)
    const ss = default_single_style()

    return (
        <div className={classes.PullEntry}>
            <div className={classes.PullHeader}>
                {props.num}. {t("misc:SeedListing.Pull")}
            </div>
            <Select
                defaultValue={reward_types[0]}
                name="reward_types"
                options={reward_types}
                value={props.value}
                styles={ss}
                onChange={elem => props.onChange(elem, props.idx)}
                formatOptionLabel={elem => {
                    return (
                        <div className={classes.Entry}>
                            {format_grade(elem.original)}
                            <span>{elem.label}</span>
                        </div>
                    )
                }}
            />
        </div>
    )
}

export default ControlInit
